import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import imageType from '../../types/image';
import ImageDropzone from '../Dropzone/ImageDropzone';
import ImageUploadPlaceholder from './ImageUploadPlaceholder';
import Image from './Image';

const useStyles = makeStyles(theme => ({
  imageWithDropZoneContainer: {
    position: 'relative',
    overflow: 'hidden',
    background: theme.palette.grey[50]
  },
  rootNormal: {
    minHeight: 200
  },
  rootLarge: {
    minHeight: 300
  }
}));

const ImageWithDropzone = ({
  image,
  thumbnailHeight,
  thumbnailWidth,
  onUploadImage,
  size = 'normal',
  action = '',
  dishLabel = null,
  isUsed,
  logoUseIn
}) => {
  const classes = useStyles();
  // console.log(dishLabel,"dishLabel")
  return (
    <div className={classes.imageWithDropZoneContainer}>
      <ImageDropzone
        thumbnailHeight={thumbnailHeight}
        thumbnailWidth={thumbnailWidth}
        onUploadImage={onUploadImage}
        action={action}
        isUsed={isUsed}
        logoUseIn={logoUseIn}
      >
        {image && <Image image={image} size={size} dishLabel={dishLabel} />}
        {!image && <ImageUploadPlaceholder size={size} />}
      </ImageDropzone>
    </div>
  );
};

ImageWithDropzone.propTypes = {
  image: imageType,
  thumbnailHeight: PropTypes.number,
  thumbnailWidth: PropTypes.number,
  onUploadImage: PropTypes.func,
  size: PropTypes.oneOf(['normal', 'large'])
};

export default ImageWithDropzone;
